import { createAppKit } from '@reown/appkit/react';
import { Ethers5Adapter } from '@reown/appkit-adapter-ethers5';
import { polygon, avalanche, optimism, bsc } from '@reown/appkit/networks';
//import { createSIWEConfig, formatMessage } from '@reown/appkit-siwe';


// Get your project ID from https://cloud.reown.com
const projectId = process.env.REACT_APP_REOWN_PROJECT_ID || 'YOUR_PROJECT_ID_HERE';



/*
export const siweConfig = createSIWEConfig({
  // 1. Dynamic Nonce
  getNonce: async () => {
    const dynamicNonce = Date.now().toString(); 
    console.log("SIWE Link Mode Trigger - Nonce:", dynamicNonce);
    return dynamicNonce;
  },

  // 2. Auth Parameters (Must match your Reown Cloud settings)
  getMessageParams: async () => ({
    domain: 'web3debitland.pages.dev',
    uri: 'https://web3debitland.pages.dev/pay',
    chains: [137, 10, 56, 43114], // Polygon
    statement: 'Welcome to NoxPay. Sign to confirm your PWA session.'
  }),

  // 3. Formatter
  createMessage: ({ address, ...args }) => formatMessage(args, address),

  // 4. Verification Mock (Returns true to trigger the auto-redirect)
  verifyMessage: async ({ message, signature }) => {
    console.log("Signature received. Verified Mock. Redirecting to PWA...");
    return true; 
  },

  // 5. Session Logic (Return null to force a new sign-in)
  getSession: async () => null,

  // 6. Required Sign Out Mock
  signOut: async () => {
    console.log("Signing out...");
    return true;
  }
});
*/



// Metadata for your dApp
const metadata = {
  name: 'NoxPay',
  description: 'NOX Pay',
  url: 'https://web3debitland.pages.dev/pay',
  icons: ['https://web3debitland.pages.dev/logo192.png'],
//  redirect: {
//    native: 'https://web3debitland.pages.dev/pay',
//    universal: 'https://web3debitland.pages.dev/pay',
//    linkMode: true
//  }
};

// Configure supported networks
const networks = [polygon, avalanche, optimism, bsc];


export const appKit = createAppKit({
  adapters: [new Ethers5Adapter()],
  networks,
  metadata,
  projectId,
  //siweConfig, // 👈 Make sure this line is here!
  features: {
    analytics: true,
    //siweConfig, // 👈 Make sure this line is here!
    email: true,        // ✅ Disable for dev
    socials: ['google'],
    //socials: [],         // ✅ Disable for dev
    emailShowWallets: true
  },
  themeMode: 'light',
  themeVariables: {
    '--w3m-accent': '#2196f3',
    '--w3m-border-radius-master': '8px'
  }
});


/*/ Create the AppKit instance with Ethers v5 adapter
export const appKit = createAppKit({
  adapters: [new Ethers5Adapter()],
  networks,
  metadata,
  projectId,
  features: {
    analytics: true,
    email: true,
    socials: ['google', 'github', 'apple'],
    emailShowWallets: true
  },
  themeMode: 'light',
  themeVariables: {
    '--w3m-accent': '#2196f3',
    '--w3m-border-radius-master': '8px'
  }
});
*/
export { projectId };